import type { AuthUser } from "../types/auth";
import {
  createLocalStorageGuideTourPersistence,
  type GuideTourPersistenceAdapter,
  type GuideTourPersistenceSnapshot,
} from "../../packages/guide-tour/src";

import type { GuideTourModule, GuideTourProgressStatus, GuideTourStep } from "./types";

const GUIDE_TOUR_STORAGE_NAMESPACE = "purchase-module:guide-tour";
const GUIDE_TOUR_STORAGE_VERSION = "v3";

function getGuideTourStorageKey(
  user: AuthUser | null | undefined,
  module: GuideTourModule | null | undefined,
) {
  if (!user) {
    return null;
  }
  if (!module) {
    return null;
  }

  return [
    user.type,
    String(user.id),
    user.role,
    module,
  ].join(":");
}

export function getGuideTourPersistence(
  user: AuthUser | null | undefined,
): GuideTourPersistenceAdapter<GuideTourModule> {
  return createLocalStorageGuideTourPersistence<GuideTourModule>({
    namespace: GUIDE_TOUR_STORAGE_NAMESPACE,
    version: GUIDE_TOUR_STORAGE_VERSION,
    getStorageKey: (module) => getGuideTourStorageKey(user, module),
  });
}

export function loadGuideTourPersistenceSnapshot(
  user: AuthUser | null | undefined,
  module: GuideTourModule | null | undefined,
  steps: GuideTourStep[],
): GuideTourPersistenceSnapshot {
  if (!module) {
    return {
      status: null,
      stepIndex: 0,
    };
  }

  return getGuideTourPersistence(user).load(module, steps);
}

export function persistGuideTourProgress({
  user,
  module,
  steps,
  status,
  stepIndex,
}: {
  user: AuthUser | null | undefined;
  module: GuideTourModule | null | undefined;
  steps: GuideTourStep[];
  status: GuideTourProgressStatus;
  stepIndex: number;
}) {
  if (!module) {
    return;
  }

  getGuideTourPersistence(user).save({
    module,
    status,
    stepIndex,
    steps,
  });
}

export function clearGuideTourProgress(
  user: AuthUser | null | undefined,
  module: GuideTourModule | null | undefined,
) {
  if (!module) {
    return;
  }

  getGuideTourPersistence(user).clear(module);
}
